import API from './'

const category = {

	/**
	 * Get a list of categories.
	 */
	list(params={}, config={})
	{
		let url = API.getUrl(`categories`)

		return API.client().get(url, { params, ...config })
	},

	/**
	 * Get one category details.
	 */
	one(slug, params={}, config={})
	{
		let url = API.getUrl(`category/${slug}`)

		return API.client().get(url, { params, ...config })
	},

}

export default category